import { Exception } from 'common/exceptions/Exception';

export class OutlookApiException extends Exception {
  apiResponse: unknown;
  constructor(message: string, apiResponse: unknown) {
    // Check if apiResponse is an object, has a statusCode property, and statusCode is -1
    if (
      apiResponse &&
      typeof apiResponse === 'object' &&
      'statusCode' in apiResponse &&
      apiResponse.statusCode === -1
    ) {
      message = `${message}. This could be an issue with your network or with the Microsoft Graph API server.`;
    }

    super(message);
    this.apiResponse = apiResponse;
  }
}
